import { render, staticRenderFns } from "./RequiredDocumentsMessageDeclineModal.vue?vue&type=template&id=3d0c463e&scoped=true"
import script from "./RequiredDocumentsMessageDeclineModal.vue?vue&type=script&lang=ts"
export * from "./RequiredDocumentsMessageDeclineModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c463e",
  null
  
)

export default component.exports